// 请求统一在这里 每一个都暴露出去，在需要用的地方调用

import service from "../util/HttpUtils"; // 将处理好的axios拿来用

/**
 * 登录
 * @param params
 * @param success
 * @param error
 */
export const login =function (params,success,error) {
    service.get("api/login?account="+params.account+"&password="+params.password, {
        successFun: success,
        errorFun: error
    })
}

export const webLogin =function (params,success,error) {
    service.get("webApi/login?account="+params.account+"&password="+params.password, {
        successFun: success,
        errorFun: error
    })
}
